module.exports = __webpack_public_path__ + "static/img/13.e7c28d6c.png";